export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8924.1c96aadc.jpg";